import { useFormState } from "react-final-form";
import { useTranslation } from "react-i18next";
import { shallowEqual } from "react-redux";
import { useSelector } from "src/store";
import { TextField } from "src/ui/shared/form/TextField";

import { selectProvisionings } from "@dashboard/provisioning/store/selectors";
import { Row, SectionDescription } from "@dashboard/shared/styles";
import { useTheme } from "@mui/material/styles";

import {
    CollapsibleProvider,
    CollapsibleSectionDetails,
    CollapsibleSectionSummary,
    CollapsibleSectionTitle,
    useCollapsiblePersistence,
} from "../../shared/components/CollapsibleSection";
import { Provisioning } from "../types";

export const ProductAdministration = () => {
    const theme = useTheme();
    const { t } = useTranslation(["pages"]);
    const { value, onChange } = useCollapsiblePersistence("provisioningPage.collapsedSections", "ProductAdministration");
    const provisionings = useSelector(selectProvisionings, shallowEqual);
    const { values: parentFormValues } = useFormState<Partial<Provisioning>>();

    const summary = parentFormValues?.settings?.deviceManager?.trim() || undefined;

    return (
        <CollapsibleProvider initialValue={value} onChange={onChange}>
            <CollapsibleSectionSummary>
                <CollapsibleSectionTitle summary={summary}>
                    {t("pages:provisioningPage.section.productAdministration.title")}
                </CollapsibleSectionTitle>
            </CollapsibleSectionSummary>
            <CollapsibleSectionDetails>
                <SectionDescription style={{ marginBottom: theme.spacing(1) }}>
                    {t("pages:provisioningPage.section.productAdministration.description")}
                </SectionDescription>
                <Row>
                    <TextField
                        name="settings.deviceManager"
                        label={t("pages:provisioningPage.input.deviceManager.caption")}
                        disabled={!provisionings.length}
                        fullWidth
                    />
                </Row>
            </CollapsibleSectionDetails>
        </CollapsibleProvider>
    );
};
